'use client';

import React, { useState, useEffect } from 'react';
import DynamicOnboardingWizard from '@/components/DynamicOnboardingWizard';

export default function OnboardingModal() {
  const [isOpen, setIsOpen] = useState(false);

  // Check if modal should automatically open on login/new session
  const checkShouldOpen = () => {
    if (typeof window === 'undefined') return;
    if (window.location.pathname === '/onboarding') return;

    const user = localStorage.getItem('kheldrop_auth_user');
    const isCompleted = localStorage.getItem('kheldrop_onboarding_completed') === 'true';
    const hasQueryPrompt = window.location.search.includes('onboarding=true');

    if (user && (!isCompleted || hasQueryPrompt)) {
      setIsOpen(true);
    }
  };

  useEffect(() => {
    checkShouldOpen();

    const handleAuthChange = () => checkShouldOpen();
    const handleExplicitOpen = () => setIsOpen(true);

    window.addEventListener('kheldrop_auth_change', handleAuthChange);
    window.addEventListener('kheldrop_open_onboarding', handleExplicitOpen);
    window.addEventListener('storage', handleAuthChange);

    return () => {
      window.removeEventListener('kheldrop_auth_change', handleAuthChange);
      window.removeEventListener('kheldrop_open_onboarding', handleExplicitOpen);
      window.removeEventListener('storage', handleAuthChange);
    };
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    if (typeof window !== 'undefined' && window.location.search.includes('onboarding=true')) {
      const newUrl = window.location.pathname;
      window.history.replaceState(null, '', newUrl);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 99999,
        background: 'rgba(0, 0, 0, 0.75)',
        backdropFilter: 'blur(12px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px',
        overflowY: 'auto',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '960px',
          boxShadow: '0 30px 80px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 255, 255, 0.1)',
          borderRadius: '28px',
          animation: 'fadeIn 0.25s ease-out',
        }}
      >
        <DynamicOnboardingWizard isModal onClose={handleClose} />
      </div>
    </div>
  );
}
